import { Directive, HostListener, Optional, Self } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appPreventSpecialCharacters]'
})
export class PreventSpecialCharactersDirective {

  constructor(
    @Optional() @Self() private ngControl: NgControl
  ) {}

  private readonly allowedPattern = /^[\p{L}\p{N}\s'-]$/u;

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent): void {
    const allowedKeys = [
      'Backspace', 'Delete', 'Tab', 'Escape', 'Enter',
      'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown',
      'Home', 'End'
    ];

    if (allowedKeys.includes(event.key) || event.ctrlKey || event.metaKey) {
      return;
    }

    if (!this.allowedPattern.test(event.key)) {
      event.preventDefault();
    }
  }

  @HostListener('input', ['$event'])
  onInput(event: Event): void {
    const input = event.target as HTMLInputElement;
  
    const sanitized = input.value.replace(/[^\p{L}\p{N}\s'-]/gu, '');
  
    if (sanitized !== input.value) {
      input.value = sanitized;
      this.ngControl?.control?.setValue(sanitized, { emitEvent: false });
    }
  }
}